exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".contact-colorist[data-v-3bdc613f] {\n  padding-top: 1em;\n  background-color: #d9e4f3;\n  display: inline-block;\n  width: 100%;\n}\n.contact-colorist p[data-v-3bdc613f] {\n  padding: 0.25em 5em;\n}\n.contact-colorist .support-ctas[data-v-3bdc613f] {\n  padding: 1.2em;\n}\n@media only screen and (min-width: 0px) and (max-width: 559px) {\n.contact-colorist p[data-v-3bdc613f] {\n    padding: 0.5em 1em;\n}\n}\n", ""]);

// exports
